/**
 * inyourplace-subclip-selector-server
 * Server to generate sports graphics
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: r.hutter@moovit.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PermissionGrant model module.
 * @module model/PermissionGrant
 * @version 1.0.0
 */
class PermissionGrant {
    /**
     * Constructs a new <code>PermissionGrant</code>.
     * @alias module:model/PermissionGrant
     */
    constructor() { 
        
        PermissionGrant.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PermissionGrant</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PermissionGrant} obj Optional instance to populate.
     * @return {module:model/PermissionGrant} The populated <code>PermissionGrant</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PermissionGrant();

            if (data.hasOwnProperty('principalType')) {
                obj['principalType'] = ApiClient.convertToType(data['principalType'], 'String');
            }
            if (data.hasOwnProperty('principalName')) {
                obj['principalName'] = ApiClient.convertToType(data['principalName'], 'String');
            }
            if (data.hasOwnProperty('permission')) {
                obj['permission'] = ApiClient.convertToType(data['permission'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PermissionGrant</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PermissionGrant</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['principalType'] && !(typeof data['principalType'] === 'string' || data['principalType'] instanceof String)) {
            throw new Error("Expected the field `principalType` to be a primitive type in the JSON string but got " + data['principalType']);
        }
        // ensure the json data is a string
        if (data['principalName'] && !(typeof data['principalName'] === 'string' || data['principalName'] instanceof String)) {
            throw new Error("Expected the field `principalName` to be a primitive type in the JSON string but got " + data['principalName']);
        }
        // ensure the json data is a string
        if (data['permission'] && !(typeof data['permission'] === 'string' || data['permission'] instanceof String)) {
            throw new Error("Expected the field `permission` to be a primitive type in the JSON string but got " + data['permission']);
        }

        return true;
    }


}



/**
 * @member {module:model/PermissionGrant.PrincipalTypeEnum} principalType
 */
PermissionGrant.prototype['principalType'] = undefined;

/**
 * @member {String} principalName
 */
PermissionGrant.prototype['principalName'] = undefined;

/**
 * @member {module:model/PermissionGrant.PermissionEnum} permission
 */
PermissionGrant.prototype['permission'] = undefined;





/**
 * Allowed values for the <code>principalType</code> property.
 * @enum {String}
 * @readonly
 */
PermissionGrant['PrincipalTypeEnum'] = {

    /**
     * value: "GROUP"
     * @const
     */
    "GROUP": "GROUP",

    /**
     * value: "ROLE"
     * @const
     */
    "ROLE": "ROLE"
};


/**
 * Allowed values for the <code>permission</code> property.
 * @enum {String}
 * @readonly
 */
PermissionGrant['PermissionEnum'] = {

    /**
     * value: "VIEW"
     * @const
     */
    "VIEW": "VIEW",

    /**
     * value: "EDIT"
     * @const
     */
    "EDIT": "EDIT",

    /**
     * value: "MANAGE"
     * @const
     */
    "MANAGE": "MANAGE"
};



export default PermissionGrant;

